import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import gm from "./globalMixin";
import VueUid from 'vue-uid';
import VueLocalStorage from 'vue-localstorage';
import store from './store'
import "vue-virtual-scroller/dist/vue-virtual-scroller.css"
import VueVirtualScroller, { RecycleScroller as Comp } from 'vue-virtual-scroller'


const cyappVersion = '1.1.7.14'
const commandPath = 'pcmd'
const serverURL = 'https://choiyomi.info/'
const dataDir = 'books/dat'
const shareDir = 'cyshare'
const debugOut = false

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBbcGqYutfZ1NsGb4BD_Jxbu8u90gElV9A",
  authDomain: "choiyomi-55998.firebaseapp.com",
  databaseURL: "https://choiyomi-55998.firebaseio.com",
  projectId: "choiyomi-55998",
  storageBucket: "choiyomi-55998.appspot.com",
  messagingSenderId: "903043218582",
  appId: "1:903043218582:web:c0ab5efd75337939"
}


Vue.use(VueUid);
Vue.use(VueLocalStorage, {
  name: 'ls',
  bind: true
});
Vue.use(VueVirtualScroller)

Vue.mixin(gm);

Vue.config.productionTip = false;

firebase.initializeApp(firebaseConfig)
firebase.auth().onAuthStateChanged(async user => {
  user = user ? user : {}
  if (debugOut) {console.log(`AuthState Changed (${user.email})`)}
  if (user.uid) {
    if (debugOut) {console.log('login!')}
    let db = firebase.firestore()
    try {
      let doc = await db.collection('users').doc(user.uid).get()
      if (doc.exists) {
        if (doc.data().testkey) {
          store.commit('setNowLockKey', doc.data().testkey)
          if (debugOut) {console.log('get test key!')}
        }
      }
    } catch(e) {
      if (debugOut) {console.log("Error getting document:", e)}
      store.commit('setNowLockKey', "")
    }
    store.commit('setNowUserID',user.email)
  }
})
const amaAffiUrl = 'https://amazon.co.jp/exec/obidos/ASIN/'

// router.beforeEach((to, from, next) => {
//   if (debugOut) {console.log('before enter');}
//   if (from.name == 'book') {
//     let nav = document.getElementById('nav');
//     nav.style.display = 'block';
//   }
//   next();
// });
router.afterEach((to,from) => {
  if (from.name == 'book') {
    let nav = document.getElementById('nav');
    nav.style.display = 'block';
  }
});

new Vue({
  router,
  store,
  render: h => h(App),
  cyappVersion: cyappVersion,
  commandPath: serverURL + commandPath,
  serverPath: serverURL,
  dataDir: dataDir,
  sharePath: serverURL + shareDir,
  amaAffiUrl: amaAffiUrl,
  debugOut: debugOut,
}).$mount("#app");
